import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getApiRequest } from '../../services/getApiRequest';

/** Safe SearchId from query string (handles `?SearchId=x&IsCombination=true` and underscore suffixes). */
function getSearchIdFromWindowLocation() {
	try {
		const qs = window.location.search.startsWith("?")
			? window.location.search.slice(1)
			: window.location.search;
		const params = new URLSearchParams(qs);
		const id = params.get("SearchId") || params.get("searchId");
		if (id) return String(id).split("_")[0];
	} catch (e) {
		/* ignore */
	}
	const q = window.location.search;
	const marker = "SearchId=";
	const idx = q.indexOf(marker);
	if (idx === -1) return "";
	return q
		.slice(idx + marker.length)
		.split("&")[0]
		.split("_")[0];
}

const getFlightSearchParams = createAsyncThunk('api/getFlightSearchParams', (searchId, navigate) => {
	let ApiRequest = getApiRequest();
	return ApiRequest({
		url: 'Flight/getFlightSearchParams',
		method: 'post',
		data: {
			searchId: getSearchIdFromWindowLocation(),
		},
	})
		.then(function (response) {
			if (response.status == '200' && response.data.message == 'ok') {
				if (response.data.data) {
					return response.data.data;
				} else {
					navigate("/")
					return false;
				}

			} else {
				window.location.replace(process.env.REACT_APP_BASE_URL);
				navigate(process.env.REACT_APP_BASE_URL)
				return false;
			}
		})
		.catch(function (error) {

			window.location.replace(process.env.REACT_APP_BASE_URL);

			console.log(error);
			navigate("/")
			return false;
		});
});

const flightSearch = createSlice({
	name: 'flightSearch',
	initialState: {
		flightSearch: {},
		error: '',
		loading: false,
	},
	reducers: {
		setFlightSearchData: (state, action) => {
			
			state.flightSearch = action.payload.data;
			state.loading = false;
		},
		setFlightSearchDataWego: (state, action) => {

			state.flightSearch = action.payload;
			state.loading = false;
		},
	},
	extraReducers: {
		[getFlightSearchParams.fulfilled]: (state, action) => {

			if (action.payload != undefined) {
				state.loading = false;
				state.flightSearch = action.payload;
			}

		},
		[getFlightSearchParams.pending]: state => {
			state.loading = true;
		},
		[getFlightSearchParams.rejected]: state => {

			state.loading = false;
			state.error = 'flightSearch Error';
		},
	},
});
export const { setFlightSearchData, setFlightSearchDataWego } = flightSearch.actions;
export { getFlightSearchParams };
export default flightSearch.reducer;